const labels = {
  carrier: 'Carrier SSO',
  decisiv: 'Decisiv Okta',
  ementra: 'Enterprise Entra ID',
  hino: 'Hino SSO',
  hinob2c: 'Hino B2C SSO',
  paccar: 'Paccar SSO',
  unassigned: 'Unassigned',
};

const ssoProviderLabelMap = (key) => {
  return labels[key] || '';
};

export default ssoProviderLabelMap;
